import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormService } from './services/form.service';
import { GeneralService } from './services/general.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    FormService,
    GeneralService
  ]
})
export class CoreModule { }
